module.exports = __webpack_public_path__ + "img/icons8-asteroid-64.7bc51df6.png";